// Display copy only; protocol values and user data are not translated.
export default {
  "URL not available": "URL no disponible",
  "Extracts:": "Extrae:",
  "Stop on fail": "Detener si falla",
  "Run Condition (optional)": "Condición de ejecución (opcional)",
  "Use:": "Usa:",
  "with operators (==, !=, >, <, &&, ||)": "con operadores (==, !=, >, <, &&, ||)",
  "Variable Flow:": "Flujo de variables:",
  "Variables extracted from earlier steps will be available in later steps via": "Las variables extraídas en los primeros pasos estarán disponibles en los siguientes mediante la sintaxis",
  "syntax.": ".",
  "AI Suggestion: Tests that can use your extracted variables": "Sugerencia de IA: pruebas que pueden usar tus variables extraídas",
  "uses": "usa",
  "Add": "Agregar",
  "Add Test to Chain:": "Agregar prueba a la cadena:",
  "extractions": "extracciones",
  "Step {v0}": "Paso {v0}",
  "Chain Name *": "Nombre de la cadena *",
  "User Authentication Flow": "Flujo de autenticación de usuarios",
  "No Environment": "Sin entorno",
  "Description": "Descripción",
  "Describe what this chain tests...": "Describe qué valida esta cadena...",
  "Chain Steps (": "Pasos de la cadena (",
  "No steps added yet. Select a test below to add it as a step.": "Aún no hay pasos. Selecciona una prueba de abajo para agregarla.",
  "steps": "pasos",
  "Created": "Creado",
  "Environment linked": "Entorno vinculado",
  "Running...": "Ejecutando...",
  "Wait...": "Espera...",
  "Run Chain": "Ejecutar cadena",
  "= Extracted variable": "= Variable extraída",
  "Uses:": "Usa:",
  "All Steps Passed": "Todos los pasos aprobados",
  "Partially Completed": "Completada parcialmente",
  "Chain Failed": "La cadena falló",
  "Total:": "Total:",
  "Passed:": "Aprobados:",
  "Failed:": "Fallidos:",
  "Skipped:": "Omitidos:",
  "Duration:": "Duración:",
  "Extracted Variables (Runtime Context)": "Variables extraídas (contexto de ejecución)",
  "Step-by-Step Results:": "Resultados por paso:",
  "Unknown Test": "Prueba desconocida",
  "Condition Not Met": "No se cumplió la condición",
  "Condition:": "Condición:",
  "Condition error:": "Error de condición:",
  "Extracted:": "Extraído:",
  "Variables:": "Variables:",
  "Test Execution Results": "Resultados de la ejecución",
  "View detailed results from your API test execution.": "Consulta los resultados detallados de la ejecución de tu prueba de API.",
  "Execution Information": "Información de la ejecución",
  "Execution Number:": "Número de ejecución:",
  "Execution ID:": "ID de ejecución:",
  "Started:": "Inicio:",
  "Test Failure Details": "Detalles del fallo de la prueba",
  "Network Error": "Error de red",
  "Error": "Error",
  "Server returned": "El servidor devolvió",
  "status code": "como código de estado",
  "Assertion": "Validación",
  "Failed": "Fallida",
  "(got:": "(obtenido:",
  "Response Time Issue": "Tiempo de respuesta excedido",
  "Response took": "La respuesta tardó",
  "Test failed for unknown reasons. Check test configuration and try again.": "La prueba falló por motivos desconocidos. Revisa su configuración e inténtalo de nuevo.",
  "Test Passed": "Prueba aprobada",
  "Test Failed": "Prueba fallida",
  "Response Body": "Cuerpo de la respuesta",
  "No response body": "Sin cuerpo de respuesta",
  "Assertion Results": "Resultados de las validaciones",
  "Actual:": "Valor obtenido:",
  "Creating Ticket...": "Creando incidencia...",
  "Create Jira Ticket": "Crear incidencia en Jira",
  "Close": "Cerrar",
  "Status:": "Estado:",
  "Details": "Detalles",
  "Network Error:": "Error de red:",
  "assertion": "validación",
  "Test failed - click Details for more info": "La prueba falló: haz clic en Detalles para ver más información",
  "Import API Collection": "Importar colección de API",
  "Import tests from Postman collections, OpenAPI specs, or cURL commands.": "Importa pruebas desde colecciones de Postman, especificaciones OpenAPI o comandos cURL.",
  "Drop your file here or click to browse": "Arrastra el archivo aquí o haz clic para buscarlo",
  "Supports Postman Collection v2.1 (JSON) and OpenAPI 3.0 (JSON/YAML)": "Compatible con Postman Collection v2.1 (JSON) y OpenAPI 3.0 (JSON/YAML)",
  "Maximum file size: 10MB | Up to 1,000 endpoints": "Tamaño máximo: 10 MB | Hasta 1000 endpoints",
  "Choose File": "Seleccionar archivo",
  "Processing...": "Procesando...",
  "Import": "Importar",
  "Import Results": "Resultados de la importación",
  "Summary of imported API tests from your collection.": "Resumen de las pruebas de API importadas de tu colección.",
  "Import Successful!": "¡Importación completada!",
  "Your API collection has been imported": "Tu colección de API se ha importado",
  "Unknown Format": "Formato desconocido",
  "Import Failed": "La importación falló",
  "Skipped Items (": "Elementos omitidos (",
  "Next Steps": "Siguientes pasos",
  "• Your imported tests are now available in the Tests tab": "• Las pruebas importadas ya están disponibles en la pestaña Pruebas",
  "• Environment variables have been created for your API endpoints": "• Se han creado variables de entorno para los endpoints de tu API",
  "• Configure credentials in the Credentials tab if your APIs require authentication": "• Configura credenciales en la pestaña Credenciales si tus APIs requieren autenticación",
  "• Run individual tests or execute them in batches": "• Ejecuta las pruebas individualmente o por lotes",
  "View Tests": "Ver pruebas",
  "Done": "Listo",
  "Schedule Test Execution": "Programar ejecución de prueba",
  "Schedule Type": "Tipo de programación",
  "Run once at a specific time": "Ejecutar una vez en una fecha y hora determinadas",
  "Run on a regular schedule": "Ejecutar de forma recurrente",
  "Timezone": "Zona horaria",
  "Eastern Time (EST/EDT)": "Hora del Este (EST/EDT)",
  "Central Time (CST/CDT)": "Hora Central (CST/CDT)",
  "Mountain Time (MST/MDT)": "Hora de la Montaña (MST/MDT)",
  "Pacific Time (PST/PDT)": "Hora del Pacífico (PST/PDT)",
  "London (GMT/BST)": "Londres (GMT/BST)",
  "Paris (CET/CEST)": "París (CET/CEST)",
  "Tokyo (JST)": "Tokio (JST)",
  "Shanghai (CST)": "Shanghái (CST)",
  "Sydney (AEST/AEDT)": "Sídney (AEST/AEDT)",
  "Scheduled Date & Time": "Fecha y hora programadas",
  "Recurrence Pattern": "Patrón de recurrencia",
  "Daily": "Diaria",
  "Weekly": "Semanal",
  "Monthly": "Mensual",
  "Start Date": "Fecha de inicio",
  "Time of Day": "Hora del día",
  "End Date (Optional)": "Fecha de finalización (opcional)",
  "Leave blank to run indefinitely": "Deja vacío para ejecutar indefinidamente",
  "Notifications": "Notificaciones",
  "Email Notifications": "Notificaciones por correo",
  "Get email alerts when scheduled tests complete": "Recibe avisos por correo al completar las pruebas programadas",
  "In-App Notifications": "Notificaciones en la aplicación",
  "Show notifications in the app when tests complete": "Muestra notificaciones en la aplicación al completar las pruebas",
  "Create Schedule": "Crear programación",
  "Run": "Ejecutar",
  "• Environment configured": "• Entorno configurado",
  "• Auth configured": "• Autenticación configurada",
  "No API tests created yet": "Aún no hay pruebas de API",
  "Start by creating your first API test with AI or manually": "Comienza creando tu primera prueba de API con IA o de forma manual",
  "Manual Create": "Crear manualmente",
  "Edit API Test": "Editar prueba de API",
  "Create API Test": "Crear prueba de API",
  "Update your API test configuration": "Actualiza la configuración de tu prueba de API",
  "Create a new API endpoint test with request details, authentication, headers, body and assertions": "Crea una prueba de un endpoint con solicitud, autenticación, encabezados, cuerpo y validaciones",
  "Request": "Solicitud",
  "Auth": "Autenticación",
  "Headers": "Encabezados",
  "Body": "Cuerpo",
  "Assertions": "Validaciones",
  "Extract": "Extracciones",
  "Ready to save": "Lista para guardar",
  "Fill in required fields (Name, URL)": "Completa los campos obligatorios (nombre y URL)",
  "Update Test": "Actualizar prueba",
  "Create Test": "Crear prueba",
  "Test Name": "Nombre de la prueba",
  "User API Test": "Prueba de API de usuarios",
  "Method": "Método",
  "Use": "Usa la sintaxis",
  "syntax for environment variables": "para las variables de entorno",
  "Describe what this test validates...": "Describe qué valida esta prueba...",
  "Environment": "Entorno",
  "None": "Ninguno",
  "Project": "Proyecto",
  "No Project (Uncategorized)": "Sin proyecto (sin categoría)",
  "Authentication": "Autenticación",
  "Select Credential": "Selecciona una credencial",
  "No Authentication": "Sin autenticación",
  "Using credential:": "Credencial utilizada:",
  "No authentication configured. Create credentials in the Credentials tab if needed.": "No hay autenticación configurada. Crea credenciales en la pestaña Credenciales si las necesitas.",
  "Request Headers": "Encabezados de la solicitud",
  "Add custom headers to your API request": "Agrega encabezados personalizados a la solicitud de tu API",
  "Add Header": "Agregar encabezado",
  "No headers added yet. Click \"Add Header\" to add custom headers.": "Aún no hay encabezados. Haz clic en \"Agregar encabezado\" para añadirlos.",
  "Active": "Activo",
  "Key": "Clave",
  "Value": "Valor",
  "Header name": "Nombre del encabezado",
  "Header value": "Valor del encabezado",
  "Quick add common headers:": "Agregar encabezados comunes:",
  "Body Type": "Tipo de cuerpo",
  "Form Data": "Datos de formulario",
  "Raw Text": "Texto sin formato",
  "Request Body": "Cuerpo de la solicitud",
  "(GET requests typically don't have a body)": "(las solicitudes GET normalmente no tienen cuerpo)",
  "Enter request body...": "Ingresa el cuerpo de la solicitud...",
  "syntax to reference environment variables": "para referenciar variables de entorno",
  "Response Assertions": "Validaciones de la respuesta",
  "Define conditions to validate the API response": "Define condiciones para validar la respuesta de la API",
  "Add Assertion": "Agregar validación",
  "No assertions configured. Add assertions to validate response status, body content, or headers.": "No hay validaciones configuradas. Agrégalas para validar el estado, el cuerpo o los encabezados de la respuesta.",
  "Status is 200 OK": "El estado es 200 OK",
  "+ Status Code = 200": "+ Código de estado = 200",
  "Response under 1s": "Respuesta en menos de 1 s",
  "+ Response Time < 1s": "+ Tiempo de respuesta < 1 s",
  "Status Code": "Código de estado",
  "Response Time (ms)": "Tiempo de respuesta (ms)",
  "Body Contains": "El cuerpo contiene",
  "JSON Path": "Ruta JSON",
  "Header Contains": "El encabezado contiene",
  "Operator": "Operador",
  "Equals": "Igual a",
  "Not Equals": "Distinto de",
  "Contains": "Contiene",
  "Less Than": "Menor que",
  "Greater Than": "Mayor que",
  "Expected Value": "Valor esperado",
  "e.g., Verify successful response": "Por ejemplo: verificar una respuesta correcta",
  "Variable Extractions": "Extracciones de variables",
  "Extract values from responses to use in subsequent API requests (data chaining)": "Extrae valores de las respuestas para usarlos en las siguientes solicitudes de API (encadenamiento de datos)",
  "Add Extraction": "Agregar extracción",
  "No extractions configured.": "No hay extracciones configuradas.",
  "Extract values from this response to use in other API tests via": "Extrae valores de esta respuesta para usarlos en otras pruebas de API mediante",
  "Extract auth token from response": "Extraer token de autenticación de la respuesta",
  "+ Extract Token ($.token)": "+ Extraer token ($.token)",
  "Extract user ID from response": "Extraer ID del usuario de la respuesta",
  "+ Extract User ID ($.user.id)": "+ Extraer ID de usuario ($.user.id)",
  "Capture response status code": "Obtener el código de estado de la respuesta",
  "+ Status Code": "+ Código de estado",
  "Variable Name": "Nombre de la variable",
  "Source": "Origen",
  "Response Headers": "Encabezados de la respuesta",
  "Header Name": "Nombre del encabezado",
  "Path (JSONPath/Dot)": "Ruta (JSONPath o notación de punto)",
  "$.data.token or user.id": "$.data.token o user.id",
  "Fallback Value (optional)": "Valor de respaldo (opcional)",
  "Default value if extraction fails": "Valor predeterminado si falla la extracción",
  "e.g., Extract auth token for subsequent requests": "Por ejemplo: extraer un token para las siguientes solicitudes",
  "Use as:": "Usar como:",
  "in headers, body, or URL of other tests": "en los encabezados, el cuerpo o la URL de otras pruebas",
  "Extraction Path Syntax:": "Sintaxis de las rutas de extracción:",
  "- JSONPath: root level \"token\"": "- JSONPath: campo \"token\" del nivel raíz",
  "- JSONPath: nested path": "- JSONPath: ruta anidada",
  "- JSONPath: array access": "- JSONPath: acceso a una lista",
  "- Dot notation": "- Notación de punto"
};
